import { AttentionBlock, Button, toast } from '@westhetics/ui'
import { useState } from 'react'
import { Link } from 'react-router'
import type { PendingItemAction, PendingItemGroup } from './api'
import { pendingTitle, seeAllLabel } from './labels'

/**
 * "Exige sua atenção" (docs/areas/dashboard.md §2; RN-DSH-13 a 16): uma linha por tipo, com a ação
 * que leva ao lugar de resolver. Até cinco linhas; a quinta vira "ver todas as N pendências" e
 * expande no lugar. Sem pendência, o bloco não existe.
 */

export const LIMIT = 5
export const RESEND_NOTE = 'O reenvio em lote chega com a área de Assinaturas.'

export function PendingAction({ action }: { action: PendingItemAction }) {
  if (action.type === 'navigate') {
    return (
      <Button variant="text" size="sm" asChild>
        <Link to={action.route}>{action.label}</Link>
      </Button>
    )
  }
  return (
    <Button variant="text" size="sm" onClick={() => toast(RESEND_NOTE)}>
      {action.label}
    </Button>
  )
}

export function PendingBlock({
  groups,
  total,
  className,
}: {
  groups: PendingItemGroup[]
  total: number
  className?: string
}) {
  const [expanded, setExpanded] = useState(false)
  if (total === 0 || groups.length === 0) return null
  const shown = expanded || groups.length <= LIMIT ? groups : groups.slice(0, LIMIT - 1)
  return (
    <AttentionBlock variant="plum" className={className} title={pendingTitle(total)}>
      <ul className="divide-hairline divide-y" aria-label="Pendências">
        {shown.map((group) => (
          <li
            key={group.type}
            className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 py-2"
          >
            <span className={group.level === 'critical' ? 'text-plum' : undefined}>
              {group.text}
            </span>
            <PendingAction action={group.action} />
          </li>
        ))}
      </ul>
      {!expanded && groups.length > LIMIT ? (
        <div className="mt-2">
          <Button variant="text" size="sm" onClick={() => setExpanded(true)}>
            {seeAllLabel(total)}
          </Button>
        </div>
      ) : null}
    </AttentionBlock>
  )
}
